module.exports = __webpack_public_path__ + "static/img/img1.e16635d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/simulator/img1.png
// module id = /VNE
// module chunks = 1